import React from 'react';
import { Toast as BootstrapToast } from 'react-bootstrap';

const Toast = ({ 
  show, 
  message, 
  onClose, 
  title = "Notification",
  bgColor = "#F16D09", // Default to brand orange for header
  autoHide = true,
  delay = 6000,
  position = "top-center",
  variant = "success", // "success", "error", "warning"
  actions = null // Optional array of action buttons: [{ label, onClick, variant }]
}) => {
  const [position1, position2] = position.split('-');
  
  // Determine colors based on variant
  const headerBg = variant === "error" ? "#dc3545" : 
                   variant === "warning" ? "#ffc107" : 
                   bgColor;
  
  const headerText = variant === "warning" ? "#000" : "white";
  
  const toastStyle = {
    position: 'fixed',
    ...(position2 === 'center' ? {
      [position1]: '20px',
      left: '50%',
      transform: 'translateX(-50%)',
      marginLeft: '120px' // Account for sidebar width
    } : {
      [position1]: '20px',
      [position2]: '20px'
    }),
    minWidth: '300px',
    maxWidth: '500px',
    zIndex: 9999,
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    border: 'none',
    borderRadius: '8px',
    overflow: 'hidden'
  };

  const headerStyle = {
    backgroundColor: headerBg,
    color: headerText,
    padding: '0.75rem 1rem',
    fontSize: '1rem',
    borderBottom: 'none',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  };

  const bodyStyle = {
    backgroundColor: 'white',
    color: '#333',
    padding: '1rem',
    fontSize: '1rem',
    lineHeight: '1.5'
  };

  const actionsStyle = {
    display: 'flex',
    gap: '0.5rem',
    justifyContent: 'flex-end',
    marginTop: '1rem'
  };

  const actionButtonStyle = (btnVariant) => ({
    padding: '0.5rem 1rem',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '0.875rem',
    backgroundColor: btnVariant === 'danger' ? '#dc3545' : 
                     btnVariant === 'secondary' ? '#6c757d' : 
                     '#F16D09',
    color: 'white',
    transition: 'opacity 0.2s'
  });

  const closeButtonStyle = {
    background: 'none',
    border: 'none',
    color: headerText,
    fontSize: '1.5rem',
    cursor: 'pointer',
    opacity: 0.8,
    padding: '0',
    lineHeight: '1',
    fontFamily: 'Arial, sans-serif' // Ensure × symbol displays correctly
  };

  return (
    <BootstrapToast 
      show={show} 
      onClose={onClose} 
      delay={delay} 
      autohide={autoHide}
      style={toastStyle}
    >
      <div style={headerStyle}>
        <span>{title}</span>
        <button 
          onClick={onClose} 
          style={closeButtonStyle}
          onMouseOver={(e) => e.target.style.opacity = '1'}
          onMouseOut={(e) => e.target.style.opacity = '0.8'}
        >
          ×
        </button>
      </div>
      <BootstrapToast.Body style={bodyStyle}>
        <div>{message}</div>
        {actions && actions.length > 0 && (
          <div style={actionsStyle}>
            {actions.map((action, index) => (
              <button
                key={index}
                style={actionButtonStyle(action.variant || 'primary')}
                onClick={action.onClick}
                onMouseOver={(e) => e.target.style.opacity = '0.9'}
                onMouseOut={(e) => e.target.style.opacity = '1'}
              >
                {action.label}
              </button>
            ))}
          </div>
        )}
      </BootstrapToast.Body>
    </BootstrapToast>
  );
};

export default Toast;